import Utils from 'Common/Utils';
import HorizontalLine from 'Components/Common/components/Button/HorizontalLine';
import { CREATE, PRODUCT_CATEGORY, SUB_MODEL, FIELD } from 'Pages/GMS/ISR/ISRConstants';
import { AddIcon } from 'assests/GmsIcons';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

type TDataModelProps = {
    onOpen: () => void;
    openFieldDialog: () => void;
    openCategoryDialog: () => void;
    openConnectorDialog: () => void;
}

const DataModelMenu = ({onOpen, openFieldDialog, openCategoryDialog}: TDataModelProps) => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);

    const handleClickOutside = useCallback(
        (e: MouseEvent) =>
            Utils.run_callback_on_click_outside_ref(e, ref, () => setShowMenu(false)),
        [ref]
    );

    useEffect(() => {
        showMenu
        ? document.addEventListener("mousedown", handleClickOutside)
        : document.removeEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, handleClickOutside, showMenu]);
    
    const handleClick = () => {
        setShowMenu((prev) => !prev);
    }

    return (
        <div ref={ref} className='tw-relative tw-bg-white tw-z-20'>        
        {/* <SquareButton onClick={handleClick} /> */}
        <button onClick={handleClick} className={`tw-rounded ${showMenu ? 'tw-bg-primary tw-text-white': 'tw-bg-shades-of-grey-0 tw-text-primary'}  tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}>
            <AddIcon color={showMenu ? "#ffffff" : "#0747A6"}  />
            {CREATE}
        </button>
            {showMenu ? (
                <div className={`tw-origin-top-left tw-mt-1 tw-right-0 tw-absolute tw-w-40 tw-mx-3 tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
                    <div className={`tw-py-1`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                        <Link to="#" onClick={() => {handleClick(); openFieldDialog();}} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">{FIELD}</Link>
                        <HorizontalLine />
                        <HorizontalLine />
                        <Link onClick={() => {handleClick(); openCategoryDialog();}}  to="#" className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">{PRODUCT_CATEGORY}</Link>
                        <HorizontalLine />
                        <Link to="#" onClick={() => {handleClick(); onOpen();}} className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">{SUB_MODEL}</Link>
                    </div>
                </div>                        
            ) : null}
        </div> 
    );
}

export default DataModelMenu;